export default "__VITE_ASSET__CW4fteHU__"